import { render, staticRenderFns } from "./InterfaceTokensModal.vue?vue&type=template&id=b925c166&scoped=true&lang=html&"
import script from "./InterfaceTokensModal.vue?vue&type=script&lang=js&"
export * from "./InterfaceTokensModal.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceTokensModal.vue?vue&type=style&index=0&id=b925c166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b925c166",
  null
  
)

export default component.exports